import _extends from 'babel-runtime/helpers/extends';
import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';

var _templateObject = _taggedTemplateLiteral(['\n        ', ';\n        ', ';\n      '], ['\n        ', ';\n        ', ';\n      ']);

import React, { PureComponent } from 'react';
import styled from 'styled-components';
import GlobalItemInner, { globalItemStyles } from '../styled/GlobalItemInner';
import DefaultLinkComponent from './DefaultLinkComponent';

var GlobalItem = function (_PureComponent) {
  _inherits(GlobalItem, _PureComponent);

  function GlobalItem() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, GlobalItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GlobalItem.__proto__ || _Object$getPrototypeOf(GlobalItem)).call.apply(_ref, [this].concat(args))), _this), _this.handleKeyDown = function (event) {
      if (event.key === 'Enter' && _this.props.onClick) {
        _this.props.onClick(event);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(GlobalItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          href = _props.href,
          CustomComponent = _props.linkComponent,
          isSelected = _props.isSelected,
          size = _props.size,
          ariaHasPopup = _props['aria-haspopup'],
          onClick = _props.onClick,
          providedMouseDown = _props.onMouseDown,
          role = _props.role,
          appearance = _props.appearance;


      var allyAndEventProps = {
        'aria-haspopup': ariaHasPopup,
        onClick: onClick,
        role: role,
        onKeyDown: this.handleKeyDown
      };

      var hoverOverrideStyles = href ? '&:hover { color: inherit; }' : '';

      if (CustomComponent) {
        var StyledComponent = styled(CustomComponent)(_templateObject, globalItemStyles, hoverOverrideStyles);
        return React.createElement(
          StyledComponent,
          _extends({
            appearance: appearance,
            href: href,
            isSelected: isSelected,
            onMouseDown: providedMouseDown,
            size: size
          }, allyAndEventProps),
          children
        );
      }
      if (href) {
        var StyledLink = styled(DefaultLinkComponent)(_templateObject, globalItemStyles, hoverOverrideStyles);
        return React.createElement(
          StyledLink,
          _extends({
            href: href,
            size: size,
            onMouseDown: providedMouseDown,
            appearance: appearance
          }, allyAndEventProps),
          children
        );
      }

      var onMouseDown = function onMouseDown(e) {
        providedMouseDown(e);
        e.preventDefault();
      };

      return React.createElement(
        GlobalItemInner,
        _extends({
          type: 'button',
          isSelected: isSelected,
          onMouseDown: onMouseDown,
          size: size,
          appearance: appearance
        }, allyAndEventProps),
        children
      );
    }
  }]);

  return GlobalItem;
}(PureComponent);

GlobalItem.defaultProps = {
  onMouseDown: function onMouseDown() {},
  size: 'small',
  appearance: 'round'
};
export default GlobalItem;